import { Col, Rate, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'
import videoConfferenceApi from 'src/api/videoConferenceApi'
import useGetWithContext from 'src/hooks/useGetWithContext'

export function RateStudent ({ studentId, code }) {
  const { t } = useTranslation()

  const { data } = useGetWithContext(`GET_RATE_CLASS_IN_${code}`, videoConfferenceApi.getSessionRecordDetail, code, { isDisabled: !code })

  if (!studentId) return null

  const { rate, cup } = useMemo(() => {
    if (!data) return { rate: '0', note: '' }
    const studentAccountDetail = data.studentAccountDetails?.find(item => item.userClientId === studentId.toString())
    const studentAccountDetailId = studentAccountDetail?.partnerIds?.find(item => item.partner === 'CLASS_IN')?.id
    const teacherRate = (data.classInData?.teacherRates || {})[studentAccountDetailId] || '0'
    const teacherCup = (data.classInData?.studentCups || {})[studentAccountDetailId] || '0'
    return { rate: teacherRate, cup: teacherCup }
  }, [data])
  if (!rate) return null

  return (
    <Col>
      <Row justify='space-between' wrap>
        <Col>
          <Rate disabled allowHalf value={Number(rate)} /><br />
          <div className='d-flex justify-content-center align-items-center'>{t('page.statistics_report.label.cup_received')}: {cup} &nbsp; <img src='/image/cup-icon.svg' style={{width: '16px', height: '16px'}}/></div>
        </Col>
      </Row>
    </Col>
  )
}
